import { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons';

import { useAuth } from '../../contexts/AuthContext';

import axios from 'axios';

const LoginModal = ({ show, registerModal, forgotPasswordModal, onClose, onLoginSuccess }) =>
{
    const [showPassword, setShowPassword] = useState(false);

    const [errors, setErrors] = useState(
    {
        email: '',
        password: ''
    });

    const [responseCode, setResponseCode] = useState('');
    const [loading, setLoading] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;

    const { email, setEmail, password, setPassword, setMessage, setResend, setToken } = useAuth();

    if (!show) return null;

    const handleClick = () =>
    {
        onClose();

        setEmail('');
        setPassword('');

        setShowPassword(false);
        setErrors(
        {
            email: '',
            password: ''
        });
    }

    const handleSubmit = async (e) =>
    {
        e.preventDefault();

        setErrors(
        {
            email: '',
            password: ''
        });

        setLoading(true);

        try
        {
            const { data } = await axios.post(`${apiUrl}/usuarios-buscadores/login`, { email, password });

            const token = data.access_token;

            setEmail('');
            setPassword('');
            setToken(token);

            setLoading(false);

            onLoginSuccess();
        }
        catch (error)
        {
            const { response } = error;

            const { data } = response;

            setErrors(data.errors);

            data.response_code && setResponseCode(data.response_code);

            setLoading(false);
        }
    };

    const handleRegister = () =>
    {
        onClose();

        setEmail('');
        setPassword('');

        setShowPassword(false);
        setErrors(
        {
            email: '',
            password: ''
        });

        registerModal();
    }

    const handleForgotPassword = () =>
    {
        onClose();

        setEmail('');
        setPassword('');

        setShowPassword(false);
        setErrors(
        {
            email: '',
            password: ''
        });

        forgotPasswordModal();
    }

    const handleVerifyCode = () =>
    {
        onClose();

        setEmail('');
        setPassword('');
        setMessage('Si necesitas obtener un nuevo código de verificación, presiona en Reenviar código.');
        setResend(true);

        setErrors(
        {
            email: '',
            password: ''
        });

        registerModal();
    }

    return (
        <div className="modal d-block fade show" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} style={{ backgroundColor: 'rgba(4, 47, 46, 0.75)', backdropFilter: 'blur(8px)', zIndex: 10050 }}>
            <div className="modal-dialog">
                <div className="modal-content">

                    <div className="modal-header border-bottom-0 pt-4 px-4 d-flex align-items-center justify-content-between text-light">
                        <h5 className="modal-title fw-medium modal-title ">{'Iniciar Sesión'}</h5>
                        <button type="button" className="btn-close  text-light" onClick={onClose}></button>
                    </div>

                    <form onSubmit={handleSubmit}>

                        <div className="modal-body p-4">
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label  font-weight-bold text-dark text-start w-100" style={{ fontSize: '12px', fontWeight: 600 }}>
                                    {'Correo Electrónico'}
                                </label>

                                <input 
                                    type="email"
                                    name="email"
                                    placeholder="Ingrese su correo"
                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    autoComplete="off"
                                />

                                {
                                    errors.email &&
                                    (
                                        <div id="emailFeedback" className="invalid-feedback">
                                            {errors.email}

                                            {
                                                responseCode === 'pending_verification' &&
                                                (
                                                    <>
                                                        {' '}
                                                        <a
                                                            className="link-primary"
                                                            onClick={() =>
                                                            {
                                                                handleRegister();

                                                                setEmail(email);
                                                                setMessage('Si necesitas obtener un nuevo código de verificación, presiona en Reenviar código.');
                                                            }}
                                                            style={{ cursor: 'pointer' }}
                                                        >{'Por favor, ingresa tu código de verificación aquí.'}</a>
                                                    </>
                                                )
                                            }

                                        </div>
                                    )
                                }

                            </div>

                            <div className="mb-3">
                                <label htmlFor="password" className="form-label font-weight-bold text-dark text-start w-100" style={{ fontSize: '12px', fontWeight: 600 }}>
                                    {'Contraseña'}
                                </label>

                                {/* Usamos input-group para fusionar el input y el botón primario */}
                                <div className={`input-group ${errors.password ? 'has-validation' : ''}`}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        placeholder="********"
                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        autoComplete="off"
                                    />

                                    {/* Botón Primario de Bootstrap con el icono blanco */}
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm bg-marine-600"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {/* Iconos de FontAwesome condicionales */}
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </button>

                                    {/* El feedback de error ahora queda integrado perfectamente gracias a 'has-validation' */}
                                    {
                                        errors.password &&
                                        (
                                            <div id="passwordFeedback" className="invalid-feedback">
                                                {errors.password}
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary px-4 uppercase fw-semibold" style={{ fontSize: '12px' }} onClick={handleClick}>{'Cancelar'}</button>
                            <button type="submit" className="btn btn-primary fw-semibold bg-marine-600" disabled={loading} style={{ fontSize: '12px' }}>
                                { !loading ? 'Iniciar Sesión' : 'Ingresando...'}
                            </button>
                        </div>

                    </form>

                    <div className="d-flex align-items-center text-center w-100">
                        <div className="col-6">
                            <p className="text-muted small">
                                {'¿No tienes una cuenta? '}
                                <button
                                    type="button"
                                    className="text-primary fw-bold text-decoration-none text-marine-600 p-0"
                                    onClick={handleRegister}
                                    style={{ background: 'none', border: 'none', verticalAlign: 'baseline' }}
                                >
                                    {'Regístrate aquí'}
                                </button>
                            </p>
                        </div>

                        <div className="col-6">
                            <p className="mb-0 small">
                                <button
                                    type="button"
                                    className="text-primary fw-bold text-decoration-none text-marine-600 p-0"
                                    onClick={handleForgotPassword}
                                    style={{ background: 'none', border: 'none', verticalAlign: 'baseline' }}
                                >
                                    {'¿Olvidaste tu contraseña?'}
                                </button>
                            </p>
                        </div>
                    </div>

                    {/* <div className="position-relative d-flex align-items-center justify-content-center">
                        <hr className="w-75 mx-auto text-muted opacity-25" />
                        <span
                            className="position-absolute bg-white px-2 text-muted small"
                            style={{ fontSize: '0.8rem' }}
                        >
                            {'O también puedes'}
                        </span>
                    </div>

                    <div className="text-center p-2">
                        <button 
                            type="button"
                            className="text-primary fw-bold text-decoration-none text-marine-600 p-2"
                            onClick={handleVerifyCode}
                            style={{ background: 'none', border: 'none', fontSize: '0.85rem' }}
                        >
                            {'Reenviar código de verificación'}
                        </button>
                    </div> */}

                </div>
            </div>
        </div>
    );
}

export default LoginModal;
